import { FilterMenuConfig } from '../../types/filter.type';

export const DISTANCE_FILTERS: FilterMenuConfig = {
  filters: [
    {
      type: 'range',
      unit: 'm',
    },
  ],
};

export const DISTANCE_FILTER_HTTP_PARAM_NAMES: Record<string, string> = {
  min: 'minDistance',
  max: 'maxDistance',
};
